import { baseQuery } from "src/store/helpers/baseQuery";
import { keepUnusedDataFor } from "src/store/helpers/cacheLifetime";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

// `updatePolicy` writes to the caches of the endpoints below, so it is injected afterwards: inside `createApi` the
// api object does not exist yet, and referring to it there makes its own type circular.
export const policiesBaseApi = createApi({
    reducerPath: "policiesApi",
    tagTypes: ["Policies"],
    keepUnusedDataFor,
    baseQuery,
    endpoints: (builder) => ({
        getPolicies: rtkClient.getPolicies(builder),
        getPolicyById: rtkClient.getPolicyById(builder),
        createPolicy: rtkClient.createPolicy(builder),
        deletePolicy: rtkClient.deletePolicy(builder),
        assignPolicyToGroups: rtkClient.assignPolicyToGroups(builder),
        unassignPolicyFromGroups: rtkClient.unassignPolicyFromGroups(builder),
    }),
});

export const policiesApi = policiesBaseApi.injectEndpoints({
    endpoints: (builder) => ({
        updatePolicy: rtkClient.updatePolicy(builder, policiesBaseApi),
    }),
});

export const {
    useGetPoliciesQuery,
    useGetPolicyByIdQuery,
    useCreatePolicyMutation,
    useUpdatePolicyMutation,
    useDeletePolicyMutation,
    useAssignPolicyToGroupsMutation,
    useUnassignPolicyFromGroupsMutation,
    usePrefetch,
} = policiesApi;
